// Shared display formatters.

// Product display name with the flavor/variant appended in parentheses so it
// is easy to see everywhere the product appears, e.g. "Gatorade (Cool Blue)".
export const productLabel = (p) => {
  if (!p) return "";
  const name = p.name || "";
  const v = (p.variant || "").trim();
  return v ? `${name} (${v})` : name;
};
